/* eslint-disable */
import React from 'react';
import { ColDef, ITextFilterParams } from '@ag-grid-community/core';
import CellRenderClipboard from '../../Shared/DataGrid/CellRenderClipboard';

const ConnectionColumns = () => {
 const columns: ColDef[] = [];

 let column: ColDef = {
  field: 'name',
  headerName: 'Объект',
  minWidth: 700,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };
 columns.push(column);

 column = {
  field: 'buildingState',
  headerName: 'Состояние',
  minWidth: 200,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };
 columns.push(column);

 column = {
  field: 'buildingType',
  headerName: 'Тип строения',
  minWidth: 300,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  lockVisible: true,
  cellRenderer: CellRenderClipboard,
 };
 columns.push(column);

 column = {
  field: 'address',
  headerName: 'Адрес',
  minWidth: 800,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };
 columns.push(column);

 return { columns };
};

export { ConnectionColumns };
